import React from 'react'
import JiaMengGoods from '@components/LocalMerchant/JiaMengGoods'
import JiaMengHeader from '@components/JiaMeng/Header/Goods'
import WeddingPhoto from '@components/LocalMerchant/JiaMengGoods/weddingPhotoGoods'
import AddWeddingPhoto from '@components/LocalMerchant/JiaMengGoods/addWeddingPhotoGoods'
import WeddingSupervise from '@components/LocalMerchant/JiaMengGoods/weddingSuperviseGoods'
import AddWeddingSupervise from '@components/LocalMerchant/JiaMengGoods/addWeddingSuperviseGoods'
import ChooseProperty from '@components/LocalMerchant/SetMeal/Publish/ChooseProperty'
import WeddingPhotoMeal from '@components/LocalMerchant/JiaMengGoods/WeddingPhotoMeal'
import { getRouteComponent } from '@util'
import { PRIVILEGE_STORE_ID } from '@constant'

export default {
  path: 'jiaMengGoods',
  component: props => <JiaMengHeader key="jiaMengGoods" {...props} />,
  indexRoute: {
    getComponent: getRouteComponent(JiaMengGoods, {
      role: [PRIVILEGE_STORE_ID]
    })
  },
  stat: '加盟店商品管理/首页',
  childRoutes: [
    {
      path: 'weddingPhoto/:id',
      component: WeddingPhoto,
      stat: '加盟店商品管理/婚纱摄影'
    },
    {
      path: 'weddingPhoto/add/:id',
      component: AddWeddingPhoto,
      stat: '加盟店商品管理/婚礼策划/添加直供商品'
    },
    {
      path: 'weddingSupervise',
      component: WeddingSupervise,
      stat: '加盟店商品管理/婚品管理'
    },
    {
      path: 'weddingSupervise/add',
      component: AddWeddingSupervise,
      stat: '加盟店商品管理/婚品管理/添加直供商品'
    },
    {
      path: 'chooseProperty',
      component: ChooseProperty,
      stat: '加盟店商品管理/选择类目'
    },
    {
      path: 'weddingPhotoMeal',
      component: WeddingPhotoMeal,
      stat: '加盟店商品管理/选择婚纱摄影套餐类型'
    }
  ]
}
